import { isRecord } from "./record";
import type { Decoration } from "./types";

export const DECORATION_APPS = ["kiosk-big"] as const;

export type DecorationApp = (typeof DECORATION_APPS)[number];

export const isDecorationApp = (app: unknown): app is DecorationApp => DECORATION_APPS.includes(app as DecorationApp);

export const decorationForApp = (document: unknown, app: string | null | undefined): Decoration | null => {
	if (!isRecord(document)) return null;
	const { apps, ...shared } = document;
	if (!isDecorationApp(app)) return shared as Decoration;

	const own = isRecord(apps) ? apps[app] : undefined;
	return isRecord(own) ? ({ ...own, hash_sum: document.hash_sum } as Decoration) : null;
};
